import { TabsNavigationItemData } from "client/Components";
import { useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	GlobalSearchScopeIdentifier,
	GlobalSearchScopeKind,
	ScopeSearchNodeModel
} from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { never } from "client_legacy/ndaw/errors";
import { deepComparison } from "client/Misc/compareUtils";
import { convertToIdentifier } from "./useFetchGlobalSearchResults";
import { getSearchNodeUniqueId, getSearchScopeUniqueId } from "./ResultView/GlobalSearchNodeTabs";

export function useSearchResultsScopeTabs(
	scopes: readonly ScopeSearchNodeModel[]
): readonly TabsNavigationItemData<GlobalSearchScopeIdentifier | null>[] {
	return useMemo(
		(): readonly TabsNavigationItemData<GlobalSearchScopeIdentifier | null>[] => {
			const tabs: readonly TabsNavigationItemData<GlobalSearchScopeIdentifier | null>[] = scopes
				.map((x): TabsNavigationItemData<GlobalSearchScopeIdentifier> => {
					switch (x.scopeKind) {
						case GlobalSearchScopeKind.Predefined:
							return {
								value: convertToIdentifier(x),
								text: x.name,
								trackingId: getSearchNodeUniqueId(x)
							};
						case GlobalSearchScopeKind.IntegrationFlow:
							return {
								value: convertToIdentifier(x),
								text: x.name,
								trackingId: getSearchScopeUniqueId(x)
							};
						default:
							return never(x);
					}
				});

			return [
				{
					value: null,
					text: localize("_All"),
					trackingId: "GlobalSearchScope.All",
				},
				...tabs,
			];
		},
		[scopes]
	);
}

export function areSearchScopeIdentifiersEqual(
	id1: GlobalSearchScopeIdentifier | nil,
	id2: GlobalSearchScopeIdentifier | nil
): boolean {
	return deepComparison(id1, id2);
}

export function normalizeSearchScopeIdentifier(
	id: GlobalSearchScopeIdentifier
): string {
	switch (id.kind) {
		case GlobalSearchScopeKind.Predefined:
			return `Predefined|${id.predefinedKind}`;
		case GlobalSearchScopeKind.IntegrationFlow:
			return `IntegrationFlow|${id.integrationId}`;
		default:
			never(id);
	}
}